




import Vue, { PropType } from 'vue';
import { validatorInArray } from '@/utils/string';

type FaIconName =
  | 'birthday-cake'
  | 'map-marker'
  | 'envelope'
  | 'globe'
  | 'github'
  | 'twitter'
  | 'facebook'
  | 'chrome'
  | 'linkedin'
  | 'instagram'
  | 'paint-brush'
  | 'share-alt'
  | 'download'
  | 'file-alt'
  | 'print'
  | 'phone'
  | 'plus'
  | 'minus';

const faIconNameValues: FaIconName[] = [
  'birthday-cake',
  'map-marker',
  'envelope',
  'globe',
  'github',
  'twitter',
  'facebook',
  'chrome',
  'linkedin',
  'instagram',
  'paint-brush',
  'share-alt',
  'download',
  'file-alt',
  'print',
  'phone',
  'plus',
  'minus',
];

// Definition icon names which need 'fab' instead of 'fa'
const fabList: FaIconName[] = [
  'github',
  'twitter',
  'facebook',
  'instagram',
  'linkedin',
  'chrome',
];

export default Vue.extend({
  props: {
    iconName: {
      type: String as PropType<FaIconName>,
      required: true,
      validator: validatorInArray(faIconNameValues),
    },
  },
  computed: {
    base(): string {
      return fabList.includes(this.iconName) ? 'fab' : 'fa';
    },
  },
});
